import React from "react";
import Breadcrumb from "react-bootstrap/Breadcrumb";
import Table from "./Table";

import baseUrl, {
  authentication,
  deductPoints,
  updateFirstName,
  updateLastName,
  updatePoints,
  bankAverage,
  addBankAverage,
  roundAverage,
  isOhrHachaim,
  setClass,
  showWorkPoints,
  useModelPerDay,
  getBankWithDailyPoints
} from "../Utils";

class Bank extends React.Component {
  reset = () => {
    this.setState(
      {
        studentData: [],
        date: "",
        formattedDate: "",
      },
      setClass(this)
    );
  };
  boldPoints = true;
  boldWork =false;
  constructor(props) {
    super(props);
    if (showWorkPoints) {
      this.boldPoints = false;
      this.boldWork = true;
    }
    // this.getStudents()
    this.state = {
      studentData: [],
      studentBankDetails: [],
      newSubcategoryOpen: false,
      studentBankDetailsColumns: [
        {
          dataField: "date",
          text: "Date",
          sort: true,
          editable: false,
        },
        {
          dataField: "transaction_type",
          text: "Transaction Type",
          sort: true,
        },
        {
          dataField: "points",
          text: "Points",
        },
        {
          dataField: "runningTotal",
          text: "Total",
        },
        {
          dataField: "notes",
          text: "Notes",
        },
      ],
      studentColumns: [
        {dataField: "id",
        hidden: true
        },
        {
          dataField: "first_name",
          text: "First Name",
          sort: true,
          row: 1,
        },
        {
          dataField: "last_name",
          text: "Last Name",
          sort: true,
          row: 1,
        },
        {
          dataField: "bank_account_number",
          text: "Account number",
          sort: true,
          editable: false,
        }
      ]
    };

    if (!isOhrHachaim) {
      this.state.studentColumns.push(
        {
          dataField: "points",
          text: "Points",
          sort: true,
          row: 1,
          editable: true,
          formatter: (cell, row) => {
            if (this.boldPoints) {
              return this.boldedFormat(cell, row)
            } else {
              return cell;
            }
          }
        }
      );
    }
    
    this.state.studentColumns.push(
    {
      dataField: "marks",
      text: "Marks",
      sort: true,
      editable: false,
    }
    );
    if (isOhrHachaim) {
      
    this.state.studentColumns.push(
      {
        dataField: "deviation",
        text: "Minuses",
        sort: true,
        editable: false,
      }
      );
    }

    if (showWorkPoints) {
      this.state.studentColumns.push(
        {
          dataField: "behavior_marks",
          text: "Behavior",
          sort: true,
          editable: false,
        },
        {
          dataField: "work",
          text: "Work",
          sort: true,
          editable: false,
        },
        {
          dataField: "late",
          text: "Late",
          sort: true,
          editable: false,
        });
    }

    this.state.studentColumns.push(
        {
          dataField: "tests",
          text: "Missing Tests",
          sort: true,
          editable: false,
          formatter: (cell, row) => {
            if (this.boldWork) {
              return this.boldedFormat(cell, row)
            } else {
              return cell;
            }
          }
        },
        {
          dataField: "retake",
          text: "Missing Retakes",
          sort: true,
          editable: false,
          formatter: (cell, row) => {
            if (this.boldWork) {
              return this.boldedFormat(cell, row)
            } else {
              return cell;
            }
          }
        },
        {
          dataField: "grade",
          text: "Grade",
          sort: true,
          editable: false,
        },
        {
          dataField: "class",
          text: "Class",
          sort: true,
          editable: false,
        });

      if (getBankWithDailyPoints) {
        this.state.studentColumns.push(
          {
            dataField: "ytd_points",
            text: "Total Points",
            sort: true,
            editable: false,
          }
        );

      } else {
        this.state.studentColumns.push(
        {
          dataField: useModelPerDay ? "model" : "percentOfModel",
          text: showWorkPoints ? "Behavior %" : "%",
          sort: true,
          editable: false,
        }
        );
      }

    if (bankAverage) {
      this.state.studentColumns.push({
        dataField: "average",
        text: "Test Average",
        sort: true,
        editable: false,
        formatter: (cell, row) => {
          return roundAverage(cell);
        },
      });
    }

    if (showWorkPoints) {
      this.state.studentColumns.push(
        {
          dataField: 'df1',
          isDummyField: true,
          text: 'Total Average',
          formatter: (cellContent, row) => {
            return (
              ((row.average != "NA") ? 
                (isNaN(row.average) || (!(row.average)) || (!row.model)) ? "NA" :
              roundAverage((row.average + row.model) /2) : row.model)
            );
          },
          headerFormatter:  this.addCloseColumn
        }
      );
    }
    setClass(this);
  }

  getBankTransactions(studentId) {
    fetch(`${baseUrl}/bank-transactions/${studentId}`, {
      headers: {
        Authorization: authentication,
      },
    })
      .then((response) => {
        return response.json();
      })
      .then((res) => {
        this.setState({ studentBankDetails: res });
      });
  }
  
  expandRow = {
    renderer: (row, rowIndex) => (
      <Table
      editable={false}
      paginationDownward={true}
      pagination={true}
      search={false}
      switch={false}
      delete={false}
        columns={this.state.studentBankDetailsColumns}
        data={this.state.studentBankDetails} 
      />
    ),       

    onExpand: (row, isExpand, rowIndex, e) => { 
      console.log('row is now expanded', row.id);
      this.getBankTransactions(row.id);
    }
  };
  
  validate = () => {
    if (this.state.formattedDate == "") {
      alert("Please Select A Date.");
      return false;
    }
    return true;
  };
  submit = () => {
    if (this.validate()) {
      let students = {
        students: this.state.studentData,
        date: this.state.formattedDate,
      };
      students = JSON.stringify(students);

      let formData = new FormData();
      formData.append("data", students);
      fetch(`${baseUrl}/redeem-rewards`, {
        method: "POST",
        body: formData,
        headers: {
          Authorization: authentication,
        },
      })
        .then((response) => response.text())

        .then((text) => {
          students = "";

          if (text == "successful") {
            this.reset();
          } else {
            alert("error" + text);
          }
        });
    }
  };

  boldedFormat = (cell, row) => { 
    if (row.tests != "" || row.retake != "" || row.marks < -4) {
      return (
        <span
          style={{
            width: "100%",
            height: "100%",
            background: "black",
            padding: "0px",
          }}
        >
          <strong style={{ color: "white" }}>{cell} </strong>
        </span>
      );
        }
        return <span>{cell}</span>
    }

  getStudents = () => {
    var url = new URL("http://ohrhatorah.appsenses.com/students.php");
    fetch(url)
      .then((response) => {
        return response.json();
      })
      .then((res) => {
        // console.log(res)
        res.forEach((a) => {
          a.id = parseInt(a.id);
          a.points = parseInt(a.points);
        });
        this.setState({ subcategories: res });
      });

    // this.setState({isSubcategoryDialogOpen:true})
  };


  render() {
    return (
      <div>
        <Breadcrumb>
          <Breadcrumb.Item href="Home">Home</Breadcrumb.Item>
          <Breadcrumb.Item active>Rewards</Breadcrumb.Item>
          <Breadcrumb.Item active>Bank</Breadcrumb.Item>
        </Breadcrumb>

        <div style={{ padding: "15px" }}>
          <div
            className="row"
            style={{ textAlign: "center", paddingBottom: "15px" }}
          >
            <div
              className="col-sm-12 col-lg-6"
              style={{ paddingTop: "10px" }}
            ></div>

            <div
              className="col-sm-12 col-lg-6"
              style={{ paddingRight: "30px", paddingBottom: "10px" }}
            >
              {/* <Button style={{float:"right"}} onClick={()=>{this.submit()}}>
                                    Save
                                </Button>*/}
            </div>
          </div>

          {this.state.studentData != undefined ? (
            <Table
              paginationDownward={true}
              delete={false}
              selectable={false}
              expandRow={this.expandRow}
              editFunc={(oldValue, newValue, row, column) => {
                {
                  if (oldValue != newValue) {
                    if (column.dataField == "points") {
                      let points = newValue - oldValue;
                      deductPoints(row.id, points);
                    }
                    if (column.dataField == "first_name") {
                      updateFirstName(row.id, newValue);
                    }
                    if (column.dataField == "last_name") {
                      updateLastName(row.id, newValue);
                    }
                  }
                }
              }}
              columns={this.state.studentColumns}
              data={this.state.studentData}
            />
          ) : (
            ""
          )}
        </div>
      </div>
    );
  }
}
export default Bank;
